import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTRBIUpdateCustomerBirthdayThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTRBIUpdateCustomerBirthdayThenSendMacroNode/DTRBIUpdateCustomerBirthdayThenSendMacroNode';

const RbiUpdateCustomerBirthdayThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTRBIUpdateCustomerBirthdayThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'Customer birthday has been updated.'}
    />
  );
};

export default RbiUpdateCustomerBirthdayThenSendMacro;
